import { NonIdealState } from "@blueprintjs/core";
import { FGCustomPanel, FGSelectInput, FGTextAreaInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGSRSHDateMaskInput } from "../../../../components";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { RequestTransientPersonSelection } from "../../../../pages/request/request/item/RequestTransientPersonSelection";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";

export interface IDrupalKennelOwnershipChangeRequestFormProps {
  kennelOwnershipChangeRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalKennelOwnershipChangeRequestForm: React.FunctionComponent<IDrupalKennelOwnershipChangeRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const [openedKennels, okloading] = useReferential((a) => a.getOpenedKennels(initialdata?.kennelId), true, []);

  return (
    <DrupalFormGenerator
      initialValues={initialdata}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      saving={false}
      deleting={false}
      hideButtons
    >
      <FieldGroup columns={2} fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}>
        <div>
          <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} />
          {initialdata?.request?.status === ERequestState.EXECUTED && (
            <FieldGroup columns={2}>
              <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
            </FieldGroup>
          )}
        </div>
      </FieldGroup>
      <DrupalFieldSet title={t(ETLCodes.KennelOwnershipChange)}>
        <FieldGroup columns={2}>
          <div>
            <FGSelectInput name="kennelId" label={t(ETLCodes.Kennel)} items={openedKennels} loading={okloading} />
          </div>
          <FGTextAreaInput label={t(ETLCodes.Remark)} name="request.remark" growVertically rows={6} />
        </FieldGroup>
      </DrupalFieldSet>
      {/* <DrupalFieldSet title={t(ETLCodes.Owners)}>
        <FGCustomPanel>
          {({ formik }) =>
            formik?.values?.kennelId ? (
              <>
                <RequestTransientPersonSelection
                  linkedIds={formik?.values?.transientOwnerIds || null}
                  onLinkedIdsChanged={(ids) =>
                    formik?.setFieldValue("transientOwnerIds", ids)
                  }
                  editMode={false}
                  loading={loading}
                  kennelId={formik?.values?.kennelId}
                />
              </>
            ) : (
              <NonIdealState
                icon="resolve"
                description={t(ETLCodes.PleaseSelectAKennelToEditOwners)}
              />
            )
          }
        </FGCustomPanel>
      </DrupalFieldSet> */}
      <DrupalStepperButtonBloc backOnly />
    </DrupalFormGenerator>
  );
};
